import { type QueryFunctionContext, queryOptions } from '@tanstack/react-query';
import { getHttpFromQueryFnContext } from '../api/getHttpFromQueryMeta';
import { QueryKeys } from '../api/queryKeys';
import { fetchSession } from './fetchSession';

export const sessionQueryKey = [QueryKeys.SESSION] as const;

export const getSessionQueryOptions = queryOptions({
  queryKey: sessionQueryKey,
  queryFn: (context: QueryFunctionContext) => {
    const http = getHttpFromQueryFnContext(context);
    return fetchSession(http);
  },
  staleTime: 'static',
  gcTime: Infinity,
  retry: false,
  meta: {
    disableNotification: true,
  },
});
